<template>
  <div style="width: 90vw">
    <el-container style="padding: 25px 25px">


      <div class="bbb1">

        <el-header style="display: flex;height: 40px;">

          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <span class="style-title">日期:</span>

          <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
              size="mini"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions3">
          </el-date-picker>

          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>

          <el-popover placement="right" width="400" trigger="click" style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black">
            <el-checkbox-group v-model="colOptions">
              <el-checkbox v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
            </el-checkbox-group>
            <el-button slot="reference" size="mini"
                       style="">
              设置字段
            </el-button>
          </el-popover>

<!--          <download-excel style="margin-left: 2px" :data="json_data"-->
<!--                          :fields="json_fields"-->
<!--                          name="数据.xls" :fetch="createExportData">-->
<!--            <el-button size="mini"-->
<!--                       style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black;">下载表格-->
<!--            </el-button>-->
<!--          </download-excel>-->


        </el-header>
        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            border
            max-height="79vh"
            height="79vh"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgb(244,244,245)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row

        >

          <el-table-column
              align="center"
              type="selection"
              width="44">
          </el-table-column>
          <el-table-column
              prop="cDate"
              label="游戏/日期"
              min-width="140"
              sortable
              show-tooltip-when-overflow
          >
            <template slot-scope="scope">

              <div style="color: black">
                <router-link  target='_blank' tag='a' :to="{name:'AdvertisingPyramid',query:{name:scope.row.aname,date:scope.row.cDate }}"
                             style="text-decoration:none;color: #058cee">{{ scope.row.aname }}
                </router-link>
              </div>
              <div style="color: #969AA0">{{ scope.row.cDate}}</div>
            </template>
          </el-table-column>

          <el-table-column
              prop="cAmount"
              label="账面消耗"
              min-width="100"
              v-if="colData[0].istrue"
              sortable
              :formatter="value_format"
          >

          </el-table-column>
          <el-table-column
              prop="cAmount"
              label="实际消耗"
              v-if="colData[1].istrue"
              min-width="100"
              sortable
              :formatter="value_format"
          >
            <template slot-scope="scope" >
            <span  v-if="scope.row.cAmount===scope.row.cAmount-scope.row.bfUv">{{(scope.row.cAmount-scope.row.bfUv)/100|dataFilters}}</span>
              <span style="color: #6c3907" v-else>{{(scope.row.cAmount-scope.row.bfUv)/100|dataFilters}}</span>

            </template>

          </el-table-column>

          <el-table-column
              prop="bfUv"
              label="实际赔付"
              min-width="100"
              sortable
              :formatter="value_format"
          >

          </el-table-column>
          <el-table-column
              prop="sum"
              label="实时ROI"
              min-width="100"
              sortable
              :formatter="value_format"
          >
            <template slot-scope="scope" >
                            {{ (scope.row.sum*100/scope.row.cAmount*100).toFixed(2)}}
                          </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="validClickCount"-->
          <!--              label="出价消耗"-->
          <!--              fixed-->

          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              {{ scope.row.validClickCount * scope.row.payCount===0?'-':scope.row.validClickCount * scope.row.payCount }}-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <!--          <el-table-column-->
          <!--              prop="payCount"-->
          <!--              label="计费转化"-->
          <!--              fixed-->

          <!--          >-->

          <!--          </el-table-column>-->
          <el-table-column
              v-for="(item, index) in items"
              :prop="'data.day'+index"

              :key="index+''"
              :label="'DAY '+(index+1)"
              width="110"
          >
            <template slot-scope="scope" >

              <div v-if="scope.row.aname==='合 计'">
                       {{ isNaN(scope.row.data['day' + index])?'-':scope.row.data['day' + index]}}

              </div>

              <div v-else>

            <div style="display: flex">

              <div style="color:#564837;font-family: Arial,serif;width: 55%"
                    v-if="Object.prototype.hasOwnProperty.call(scope.row, 'data6')">

                <div v-if="scope.row.active===5">
                   {{
                    scope.row.data6['day' + (index)] == null ? '-' : ((scope.row.data6['day' + (index)] / (scope.row.validClickCount * scope.row.payCount) * 100)).toFixed(2)
                  }}

                  </div>

                <div v-else>
                   {{
                    scope.row.data6['day' + (index)] == null ? '-' : ((scope.row.data6['day' + (index)] / scope.row.cAmount) * 10000).toFixed(2)
                  }}

                </div>

                <div style="color: rgb(234,14,14)">
                {{scope.row['r'+(index+1)]==0?'-':scope.row['r'+(index+1)]}}

                </div>



              </div>
             <span style="align-items: center;align-content:center;font-size: 10px">  {{(scope.row['r'+(index+1)]-(scope.row.data6['day' + (index)] == null ? '-' : ((scope.row.data6['day' + (index)] / scope.row.cAmount) * 10000))).toFixed(2)|dataFilters}}</span>
            </div>



</div>
            </template>
          </el-table-column>

        </el-table>


      </div>


    </el-container>

  </div>
</template>

<script>
export default {
  name: "GameBroad",

  data() {

    return {
      isSort: true,
      options2: ['+', '-', '*', '/'],
      newProp: '例如(进入游戏)',
      newPropValue: '',
      valProp2: '',
      valueSuan: '',
      colData: [{title: "账面消耗", istrue: true},
        {title: "实际消耗", istrue: false},
      ],
      colOptions: ["账面消耗"], //默认全选
      colSelect: ["账面消耗", "实际消耗"],
      valProp: '例如(1,下一关)',
      titleHeads: [{sta_value: "进入游戏", sta_view_value: "进入游戏"}, {
        sta_value: "下一关",
        sta_view_value: "进入下一关"
      }],
      list: [],
      value1: [],
      currentPage: 1,
      option_Scene: [{id: '总', value: ''}, {id: "抖音个人主页侧边栏", value: "_021001"},
        {id: '全局扫一扫', value: '_021002'}
        , {id: '抖音其他小游戏跳转', value: '_021009'}
        , {id: '抖音个人页我的小程序（个人简介下方）/ 抖音首页侧边栏', value: '_021036'}
        , {id: '抖音视频锚点', value: '_023001'}
        , {id: '抖音视频评论页锚点', value: '_023002'}
        , {id: '抖音直播间（仅自然转化，不包含发行人直播间投广告、投dou+）', value: '_023010'}
        , {id: '抖音搜索结果视频锚点', value: '_023023'}
        , {id: '抖音广告投放 （包含发行人直播间投广告、投dou+）', value: '_025001'}
        , {id: '抖极视频锚点', value: '_103001'}],
      valueScene: '',
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      tableData2: [],
    optionsGame: [],
      valueGame: "",
      options3: [{
        value: '选项1',
        label: '7'
      }, {
        value: '选项2',
        label: '14'
      }, {
        value: '选项3',
        label: '30'
      }],
      value: 0,

      ecpmA: 300,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {},
      headType: '微信默认',
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: [],
      maxHeight:800

    }


  }, watch: {

  colOptions(valArr) {
    // alert("sss");
    var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
    this.colData.filter(i => {
      if (arr.indexOf(i.title) != -1) {
        i.istrue = false;
        this.$nextTick(() => {
          this.$refs.tableDataRef.doLayout();
        });
      } else {
        i.istrue = true;
        this.$nextTick(() => {
          this.$refs.tableDataRef.doLayout();
        });
      }
    });
  }
}, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return  "-"

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  }, methods: {

    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },

    up(e) {

      if (e == 0) {

        if (this.currentPage > 1)
          this.currentPage--
        this.searchPage()

      } else {

        this.currentPage++

        this.searchPage()
      }


    }, clickTo(row) {

      console.log(row)

    },

    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },

    search(flag) {

      if(flag){

        console.log("手动选条件")

        localStorage.setItem("GameBroad", JSON.stringify({name: this.valueGame, date: this.value2}))

      }else{

        if (localStorage.getItem("GameBroad") != null) {

          console.log("自动刷")

          this.valueGame = JSON.parse(localStorage.getItem("GameBroad")).name

          this.value2 = JSON.parse(localStorage.getItem("GameBroad")).date


        }
      }

      this.maxHeight=window.innerHeight-250;
      if (this.value2 != null&&this.value2!=='') {


        this.tableData = []
        this.loading = true
        this.$axios
            .post('/toufang/data/findSum', {
              start: this.value2 == null ? '' : this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2 == null ? '' : this.value2[1],
              pf: [1],
              pingtai: [1],
              valueList: []

            })
            .then(successResponse => {

              var a = successResponse.data.total

              var b= 0

              for (var j = 0; j < successResponse.data.data.length; j++) {

                b=b+ successResponse.data.data[j].sum

              }

              a['aname'] = '合 计'
              a['cDate'] = '合 计'
              a['sum']=b
              this.tableData.push(a)
              this.tableData = this.tableData.concat(successResponse.data.data)
              console.log(this.tableData)

              for (var i = 0; i < this.tableData.length; i++) {

                this.tableData[i].cAmount = parseInt(this.tableData[i].cAmount)
              }
              console.log('成功')
              // this.querySum()
              this.$nextTick(() => {
                this.$refs['tableData1'].doLayout();
              })

              this.loading = false
            }).catch((err) => {
          //请求失败的回调函数
          console.log(err)
          console.log('失败')
        })
      }

    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {
    this.height = window.innerHeight;
    this.maxHeight=window.innerHeight-250;
      // this.date_format_new()


    this.findGame()
    this.search(false)
    for (let i = 0, len = 160; i <= 160; i++) {
      this.items.push(i + '')
    }
  }


}
</script>
<style>
.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}

.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}



.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 12px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;

  margin-top: 19px;
  min-height: 80vh;
}

</style>


<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>